<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="col-sm-12">
      <div class="card card-body">
        <div class="overflow-auto">
          <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
            <thead>
            <tr>
              <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.merchant') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.store') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.currency') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('dashboard.on_hold') }}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="storeAccount in accountItems" :key="storeAccount.account.id" class="">
              <td>
                <span v-b-tooltip.hover :title="storeAccount.account.id">{{ storeAccount.account.id.substring(0, 8) }}...</span> <copy-button :value="storeAccount.account.id"></copy-button>
              </td>
              <td>
                {{ storeAccount.merchantEmail }}
              </td>
              <td>
                {{ storeAccount.storeName }}
              </td>
              <td>
                {{ storeAccount.account.currency }}
              </td>
              <td>
                {{ numberFormatter.formatNumber(storeAccount.account.sum) }}
              </td>
              <td>
                {{ numberFormatter.formatNumber(storeAccount.account.frozenSum) }}
              </td>
              <td class="text-end">
                <button v-if="accountForDetails !== null" type="button" @click.prevent="accountForDetails = null" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize">
                  <i class="fa fa-arrow-left"></i> {{ helper.trans('button.back')}}
                </button>
                <button v-else @click.prevent="accountForDetails = storeAccount" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first">
                  {{ helper.trans("menu.items.accountOperations") }}
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <b-pagination
            v-if="accounts.totalCount > accounts.items.length"
            v-model="page"
            :total-rows="accounts.totalCount"
            :per-page="accounts.limit"
            :limit="20"
            @update:modelValue="loadAccounts()"
            prev-text="Back"
            next-text="Next"
            align="start"
            first-number
            hide-goto-end-buttons
            hide-ellipsis
          ></b-pagination>

        </div>

      </div>
    </div>
    <AccountOperations v-if="accountForDetails" :account="accountForDetails.account" :class="'m-0'"></AccountOperations>
  </LoaderWrapper>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import APIClient from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import MerchantStoreAccountDTO from "@/models/MerchantStoreAccountDTO";
import AccountOperations from "@/views/AccountOperations.vue";

const api = new APIClient();

export default defineComponent({
  components: {
    LoaderWrapper,
    CopyButton,
    AccountOperations
  },
  props: {},
  setup() {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      accountForDetails: null as MerchantStoreAccountDTO|null,
      page: 1,
      accounts: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<MerchantStoreAccountDTO>
    });

    const loadAccounts = async () => {
      loader.value?.show()
      state.accounts.offset = state.accounts.limit * (state.page - 1)
      state.accounts = await api.merchantStoreAccounts(state.accounts);
      loader.value?.hide()
    }


    const accountItems = computed<MerchantStoreAccountDTO[]>(() => {
      if (state.accountForDetails === null) {
        return state.accounts.items
      }

      return [state.accountForDetails]
    })

    onMounted(() => {
      loadAccounts()
    });

    return {
      ...toRefs(state),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      loadAccounts,
      accountItems
    }
  }
})
</script>
